import React, { PureComponent } from 'react';

class AuroraAnimation extends PureComponent {
    render() {
        return (
            <div style={styles.container}>
                <style>{keyframes}</style>
                <div style={styles.band1} />
                <div style={styles.band2} />
                <div style={styles.band3} />
                <div style={styles.shimmer} />
            </div>
        );
    }
}

const keyframes = `
@keyframes aurora-wave-1 {
    0% { transform: translateX(-30%) skewX(-5deg) scaleY(0.6); opacity: 0; }
    20% { opacity: 0.7; }
    50% { transform: translateX(10%) skewX(8deg) scaleY(1.2); opacity: 0.5; }
    80% { opacity: 0.6; }
    100% { transform: translateX(40%) skewX(-3deg) scaleY(0.8); opacity: 0; }
}
@keyframes aurora-wave-2 {
    0% { transform: translateX(20%) skewX(5deg) scaleY(0.8); opacity: 0; }
    30% { opacity: 0.6; }
    60% { transform: translateX(-15%) skewX(-10deg) scaleY(1.4); opacity: 0.4; }
    100% { transform: translateX(-40%) skewX(3deg) scaleY(0.6); opacity: 0; }
}
@keyframes aurora-wave-3 {
    0% { transform: translateX(0%) skewX(0deg) scaleY(0.5); opacity: 0; }
    25% { opacity: 0.5; }
    55% { transform: translateX(20%) skewX(6deg) scaleY(1.1); opacity: 0.35; }
    100% { transform: translateX(-20%) skewX(-4deg) scaleY(0.7); opacity: 0; }
}
@keyframes aurora-shimmer {
    0% { opacity: 0; }
    30% { opacity: 0.15; }
    70% { opacity: 0.08; }
    100% { opacity: 0; }
}
`;

const bandBase = {
    position: 'absolute',
    left: '-20%',
    width: '140%',
    borderRadius: '50%',
    filter: 'blur(30px)',
};

const styles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        overflow: 'hidden',
        backgroundColor: 'rgba(0, 5, 15, 0.2)',
    },
    band1: {
        ...bandBase,
        top: '15%',
        height: '35%',
        background: 'linear-gradient(90deg, transparent 0%, #00c9a7 20%, #00d4aa 40%, #92fe9d 60%, #00c9a7 80%, transparent 100%)',
        animation: 'aurora-wave-1 2.8s ease-in-out forwards',
    },
    band2: {
        ...bandBase,
        top: '25%',
        height: '30%',
        background: 'linear-gradient(90deg, transparent 0%, #845ec2 20%, #d65db1 50%, #ff6f91 80%, transparent 100%)',
        animation: 'aurora-wave-2 2.8s ease-in-out 0.3s forwards',
    },
    band3: {
        ...bandBase,
        top: '20%',
        height: '28%',
        background: 'linear-gradient(90deg, transparent 0%, #4facfe 25%, #00f2fe 50%, #43e97b 75%, transparent 100%)',
        animation: 'aurora-wave-3 2.8s ease-in-out 0.6s forwards',
    },
    shimmer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'radial-gradient(ellipse at 50% 30%, rgba(130, 200, 255, 0.15), transparent 70%)',
        animation: 'aurora-shimmer 2.8s ease-in-out forwards',
    },
};

export default AuroraAnimation;
